module.exports = __webpack_public_path__ + "media/images/redox/REDOX_LABS_Circle-82e87c8da0ea046f25212266c57be5b1.png";